// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e0d1a47c","455":"d4dbbda5","977":"ffe14e2a"}[chunkId] + ".chunk.js";
};